<template>
	<b-list-group-item class="element-handler">
		
		<b-row align-v="center">
			
			<b-col cols="7">
				<b-form-select v-if="!displayOnly" v-model="workingValue.idpresentacion_fk" @change="presentationChanged">
					<b-form-select-option :value="null">Please select an option</b-form-select-option>
					<b-form-select-option v-for="opt in factibleOptions" 
						:key="opt.id" 
						:value="opt.presentacion_id_pk">
						{{opt.titulo_extendido}}
					</b-form-select-option>
				</b-form-select>
				<div v-else>
					<strong>{{workingValue.presentacion_textual}}</strong>
				</div>
			</b-col>
			
			<b-col cols="3" class="nowrap centered">
				<div>
					<template  v-if="authGetUser.tipoUsuario == 'Admin'">
						<strong title="Costo">{{workingValue.costo | currency}}</strong> | 
					</template>
					<strong title="Precio">{{workingValue.precio | currency}}</strong>
				</div>
			</b-col>
			
			<b-col cols="2">
				<b-form-input label="Cantidad" type="number" :readonly="displayOnly" block v-model="workingValue.cantidad" @change="cantidadChanged" />
			</b-col>
			
		</b-row>
		
	</b-list-group-item>
</template>

<script>
import _ from "lodash";
import { mapGetters } from 'vuex';
export default {
	name: "pedidoDetalleHandlerElement",
	props: {
		displayOnly: {
			type: Boolean,
			default: false
		},
        fullRequerimientosCalculo: {
            type: Array, 
            default: () => {return []}
        },
        fullFactoresDeConversion: {
            type: Array, 
            default: () => {return []}
        },
        fullCatalg: {
            type: Array, 
            default: () => {
				return []
			 }
        },
		isEditable: {
			type: [Number, String, Boolean],
			default: true
		},
		value: {
			type: [Object],
			default: () => { 
				return {
					// LOCAL INDEX
					localID: null,

					// CHECK Update
					check: null,
	
					// PRESENTACION
					idpresentacion_fk: null,
					presentacion_textual: null,
	
					// TIPO
					tipo: 1,
					costo: 0,
					precio: 0,
					total: 0,
					cantidad: 0,
			}}
		},
	},
	computed: {
		...mapGetters(['authGetUser', 'uiGetReduceUiRendimiento']),
		isEditableComputed(){
			return (this.isEditable)
		},
		maxItems(){
			return 1000
		},
		factibleOptions() {
			return _.sortBy(
				_.map(
					_.filter(this.fullCatalg, {
						idelemento_fk: this.workingValue.idelemento_fk,
						tipo: this.workingValue.tipo,
					}),
					(opt) => {
						let requirements = _.filter(this.fullRequerimientosCalculo, {
								id_pk_ingrediente: this.workingValue.idelemento_fk,
							}),
							requirementBase = requirements.length
								? _.clone(requirements[0])
								: {};


						// INICIALIZA CADA UNA DE LAS OPCIONES A ESCOGER DE PARTE DEL USUARIO
						opt.reqMin_cuantos = 0;
						opt.reqMin_subtotal = 0;

						// CANTIDAD BASE
						requirementBase.cantidad = 0;
						requirementBase.unidadmedicion;

						// REVISIÓN DE REQUISITOS
						_.forEach(requirements, (req) => {
							requirementBase.cantidad += parseFloat(req.cantidad);
						});

						// SI LA UNIDAD DE MEDICION DE LA OPCION BASE ES DIFERENTE QUE LA 
						// SOLICITADA POR EL CÁLCULO, CONVIERTE
						if (requirementBase.unidadmedicion_receta != opt.unidadmedicion) {
							console.log('selectedOption conversión de unidades')
							let cantidad = _.clone(requirementBase.cantidad),
								converFactAB = _.find(this.fullFactoresDeConversion, {
									unidadmedicion_destino: opt.unidadmedicion,
									unidadmedicion_origen: requirementBase.unidadmedicion_receta,
								}),
								converFactBA = _.find(this.fullFactoresDeConversion, {
									unidadmedicion_origen: opt.unidadmedicion,
									unidadmedicion_destino: requirementBase.unidadmedicion_receta,
								});


							if (converFactAB) {
								requirementBase.cantidad = converFactAB.factor * cantidad;
							} else if (converFactBA) {
								requirementBase.cantidad = cantidad / converFactAB.factor;
							}

						}
						opt.reqMin_cuantos =
							parseFloat(opt.presentacion) >=
							parseFloat(requirementBase.cantidad)
								? 1
								: Math.ceil(requirementBase.cantidad / opt.presentacion * (1 / ((this.uiGetReduceUiRendimiento) ? parseFloat(opt.radio_rendimiento) : 1) ));

						// CALCULO DE COSTO REQMIN SUBTOTAL
						opt.reqMin_subtotal = opt.reqMin_cuantos * opt.precio;

						return opt;
					}
				),
				["reqMin_subtotal"]
			);
		},
		selectedPresentation() {
			if (!!this.factibleOptions && !!this.workingValue.idpresentacion_fk){
				return _.find(this.factibleOptions, {
					presentacion_id_pk: this.workingValue.idpresentacion_fk,
				}) || {
					tipopresentacion: 'n/a'
				};
			}
		},
	},
	data: () => {
		return {
			multiline: false,
			originalElementItem: null,
			workingValue: null,
			check: 1,
			cantidad: 1,
			idPresentacionFk: null,
			brandOptions: null,
			subtotal: 0,
		};
	},
	methods: {
		cantidadChanged(){
			try {
				let selectedOption = this.selectedPresentation
				this.workingValue.precio = (this.workingValue.cantidad * selectedOption.precio) 
				this.workingValue.costo = (this.workingValue.cantidad * selectedOption.costo) 
			} catch(e){
				console.erro(e)
				this.workingValue.cantidad = 0
			}
		},
		presentationChanged(){
			try {
				let selectedOption = this.selectedPresentation
				this.workingValue.presentacion_textual = selectedOption.titulo_extendido
				this.workingValue.cantidad = selectedOption.reqMin_cuantos
				this.cantidadChanged()
			} catch(e){
				console.erro(e)
				this.workingValue.cantidad = 0
			}

		}
	},
	beforeMount() {
		this.originalElementItem = _.clone(this.value);
		this.workingValue = _.clone(this.value);
	},
	mounted(){
		if(!this.selectedPresentation){
			this.workingValue.idpresentacion_fk = this.factibleOptions[0].presentacion_id_pk
			this.presentationChanged()
		}
	},
	watch: {
		'workingValue.cantidad'(){
			if(!this.displayOnly)
				this.$emit('input', this.workingValue)
		},
		'workingValue.idpresentacion_fk'(){
			if(!this.displayOnly)
				this.$emit('input', this.workingValue)
		}
	}
};
</script>

<style lang="less">
.element-handler {
	.centered {
		text-align: center;
	}
	.nowrap {
		white-space: nowrap;
	}
}
</style>